import React from "react";
import { Stack, Typography, TextField, MenuItem } from "@mui/material";

export default function StationHeaderFilter({ 
  title = "LATEST STATION OPENINGS", 
  provinces = [], 
  selectedProvince, 
  onFilterChange 
}) {
  return (
    <Stack 
      direction={{ xs: "column", md: "row" }} 
      justifyContent="space-between" 
      alignItems={{ xs: "flex-start", md: "center" }}
      spacing={3}
      sx={{ mb: 6 }}
    >
      {/* LEFT: TITLE */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "#009fb6",
          mb: { xs: 2, md: 0 }, 
          mt: { xs: -6, sm: -6, md: 0 },
          ml: { lg: -10 }
        }}
      >
        {title}
      </Typography>

      {/* RIGHT: DROPDOWN */}
  <TextField
  select
  label="Filter by Province"
  value={selectedProvince}
  onChange={onFilterChange}
  variant="outlined"
  size="small"
  SelectProps={{
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: { xs: "250px", md: "400px" },
          borderRadius: 2,
          "& .MuiMenuItem-root": {
            fontSize: { xs: "1.1rem", md: "1.3rem" }, 
          },
        },
      },
    },
  }}
  sx={{
    minWidth: { xs: "100%", md: "320px" },

    // 1. INPUT TEXT SIZE
    "& .MuiOutlinedInput-root": {
      borderRadius: "30px",
      fontSize: { xs: "1.4rem" }, // Increased for readability
      "&.Mui-focused fieldset": {
        borderColor: "#009fb6",
        borderWidth: "2px",
      },
    },

    // 2. THE LABEL (BIGGER & BOLDER)
    "& .MuiInputLabel-root": {
      fontSize: { xs: "1.4rem" }, // Larger base size
      fontWeight: 500, // Added medium weight for better definition
      transform: "translate(20px, 10px) scale(1)", // Adjusts initial position inside the rounded box
      "&.Mui-focused": {
        color: "#009fb6",
      },
    },

    // 3. THE LABEL WHEN SHRUNK (TOP POSITION)
    "& .MuiInputLabel-shrink": {
      // Keeps the label large even when it moves to the top border
      transform: "translate(14px, -10px) scale(0.85) !important", 
      fontWeight: 600,
      backgroundColor: "white", // Prevents the border line from cutting through the text
      padding: "0 8px",
    },
  }}
>
        {provinces.map((option) => (
          <MenuItem 
            key={option} 
            value={option}
            sx={{ 
              fontSize: { xs: "1.3rem", md: "1.1rem" },
              minHeight: { xs: "32px", md: "48px" }, 
              py: { xs: 0.5, md: 1.5 },
            }} 
          >
            {option}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}